<div [ngSwitch]="displayForm">
  <app-login (changeView)="toggleView($event)" *ngSwitchCase="0" [email]="userEmail"></app-login>
  <app-new-registration (changeView)="toggleView($event)" *ngSwitchCase="1"></app-new-registration>
  <app-reset-password-confirm
    (changeView)="toggleView($event)"
    *ngSwitchCase="2"
    [email]="userEmail"
    [errorMessage]="reason"></app-reset-password-confirm>
</div>
